import React, { useState } from "react";
import { Box } from "@mui/material";
import TextInput from "./Comon/TextInput/TextInput";
import Headline from "./Comon/Headline/Headline";
import Button from "./Comon/Button/Button";
import Dropdown from "./Admin Panel/Dropdown/Dropdown";
import {
  practiceHubSetApiKey,
  practiceHubSyncUsers,
  practiceHubUpdateSettings,
  practiceHubToggleActive,
} from "../../core/axios/services";
import { useDispatch, useSelector } from "react-redux";
import { addUser } from "../../redux/actions/user";
import { Oval } from "react-loader-spinner";
import Accordion from "../pages/Admin Panel/SurveySettings/Accordion";
import { Tooltip as ReactTooltip } from "react-tooltip";
import MultiDropdown from "./Admin Panel/Dropdown/MultiDropdown";

const PracticeHubIncomingIntegration = ({ app, i18n, showGlobalSnackbar }) => {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const [apiKeyFormData, setApiKeyFormData] = useState({
    apiKey: user?.user?.clinic?.practiceHubSettings?.apiKey ?? '',
    accountDomain: user?.user?.clinic?.practiceHubSettings?.accountDomain ?? '',
    accountRegion: user?.user?.clinic?.practiceHubSettings?.accountRegion ?? '',
    timezone: user?.user?.clinic?.practiceHubSettings?.timezone ?? null,
  });
  const [apiKeyErrorData, setApiKeyErrorData] = useState();
  const [apiKeyStatus, setApiKeyStatus] = useState(false)

  async function handleSetApiKey() {
    setApiKeyStatus(true);
    let response = await practiceHubSetApiKey(apiKeyFormData, user);
    if (response?.status === 200) {
      dispatch(addUser(response.data.data));
      setApiKeyStatus(false);
      showGlobalSnackbar(i18n.t("saved"));
    } else {
      setApiKeyStatus(false);
      setApiKeyErrorData(response?.response?.data?.messages);
    }
  }

  let sendingOptions = [
    {id: 1, name: "Before (pending)", value: "before",},
    {id: 2, name: "After (processed)", value: "after",},
  ];
  let numOfDaysOptions = [
    {id: 0, name: "Same day", value: 0},
    {id: 1, name: "1 Day", value: 1},
    {id: 2, name: "2 Days", value: 2},
    {id: 3, name: "3 Days", value: 3},
    {id: 4, name: "4 Days", value: 4},
    {id: 5, name: "5 Days", value: 5},
    {id: 6, name: "6 Days", value: 6},
    {id: 7, name: "7 Days", value: 7},
  ];

  const [sendingInfoFormData, setSendingInfoFormData] = useState({
    defaultSurveyType: user?.user?.clinic?.practiceHubSettings?.defaultSurveyType ?? null,
    defaultSurveyLanguage: user?.user?.clinic?.practiceHubSettings?.defaultSurveyLanguage ?? null,

    //Survey 1
    emailBody: user?.user?.clinic?.practiceHubSettings?.emailBody ?? null,
    emailSubject: user?.user?.clinic?.practiceHubSettings?.emailSubject ?? null,
    appointmentTypeTriggers: user?.user?.clinic?.practiceHubSettings?.appointmentTypeTriggers ?? [],
    sendingOption: user?.user?.clinic?.practiceHubSettings?.sendingOption ? sendingOptions.find(obj => obj.value === user?.user?.clinic?.practiceHubSettings?.sendingOption) : null,
    numOfDaysSending: numOfDaysOptions.find(obj => obj.value === (user?.user?.clinic?.practiceHubSettings?.numOfDaysSending ?? null)),
    sendEmailToClinic: user?.user?.clinic?.practiceHubSettings?.sendEmailToClinic,
    sendEmailToPatient: user?.user?.clinic?.practiceHubSettings?.sendEmailToPatient,
    sendEmailToClinicAddress: user?.user?.clinic?.practiceHubSettings?.sendEmailToClinicAddress,


    //Survey 2-6
    emailBodyNext: user?.user?.clinic?.practiceHubSettings?.emailBodyNext ?? null,
    emailSubjectNext: user?.user?.clinic?.practiceHubSettings?.emailSubjectNext ?? null,
    nextAppointmentTypeTriggers: user?.user?.clinic?.practiceHubSettings?.nextAppointmentTypeTriggers ?? [],
    nextSendingOption: user?.user?.clinic?.practiceHubSettings?.nextSendingOption ? sendingOptions.find(obj => obj.value === user?.user?.clinic?.practiceHubSettings?.nextSendingOption) : null,
    nextNumOfDaysSending: numOfDaysOptions.find(obj => obj.value === user?.user?.clinic?.practiceHubSettings?.nextNumOfDaysSending ?? null),
    nextSendEmailToClinic: user?.user?.clinic?.practiceHubSettings?.nextSendEmailToClinic,
    nextSendEmailToPatient: user?.user?.clinic?.practiceHubSettings?.nextSendEmailToPatient,
    nextSendEmailToClinicAddress: user?.user?.clinic?.practiceHubSettings?.nextSendEmailToClinicAddress,
  });
  const [sendingInfoErrorData, setSendingInfoErrorData] = useState();
  const [sendingInfoStatus, setSendingInfoStatus] = useState(false)
  async function handleSendingInfo() {
    setSendingInfoStatus(true);
    let response = await practiceHubUpdateSettings({
      ...sendingInfoFormData,
      sendingOption: sendingInfoFormData?.sendingOption?.value,
      numOfDaysSending: sendingInfoFormData?.numOfDaysSending?.value,

      nextSendingOption: sendingInfoFormData?.nextSendingOption?.value,
      nextNumOfDaysSending: sendingInfoFormData?.nextNumOfDaysSending?.value,
    }, user)
    if (response?.status === 200) {
      dispatch(addUser(response.data.data));
      showGlobalSnackbar(i18n.t("saveAndSyncMessage"));
      setSendingInfoErrorData(null);
    } else {
      setSendingInfoErrorData(response?.response?.data?.messages);
    }
    setSendingInfoStatus(false);
  }

  const [syncUsersErrorData, setSyncUsersErrorData] = useState();
  const [syncUsersStatus, setSyncUsersStatus] = useState(false)
  async function handleSyncUsers() {
    setSyncUsersStatus(true);
    let response = await practiceHubSyncUsers(user);
    if (response?.status === 200) {
      dispatch(addUser(response.data.data));
      showGlobalSnackbar(i18n.t("syncSuccessMessage"));
      setSyncUsersErrorData(null);
    } else {
      setSyncUsersErrorData(response?.response?.data?.messages);
    }
    setSyncUsersStatus(false);
  }


  function surveyHasErrors(){
    return sendingInfoErrorData?.["appointmentTypeTriggers.*.id"] ||
      sendingInfoErrorData?.["sendingOption"] ||
      sendingInfoErrorData?.["numOfDaysSending"] ||
        sendingInfoErrorData?.["emailBody"] ||
        sendingInfoErrorData?.["emailSubject"]
        ;
  }
  function surveyNextHasErrors(){
    return sendingInfoErrorData?.["nextAppointmentTypeTriggers.*.id"] ||
      sendingInfoErrorData?.["nextSendingOption"] ||
      sendingInfoErrorData?.["nextNumOfDaysSending"] ||
        sendingInfoErrorData?.["emailBodyNext"] ||
        sendingInfoErrorData?.["emailSubjectNext"]
        ;
  }


  const [showFailedSyncUsers, setShowFailedSyncUsers] = useState(false);


  const [isUpdatingActiveStatus, setIsUpdatingActiveStatus] = useState(false);
  async function handleToggleActive() {
    setIsUpdatingActiveStatus(true);
    let response = await practiceHubToggleActive(user)
    if (response?.status === 200) {
      dispatch(addUser(response.data.data));

      if(response.data.data){
        if(response.data.data?.user?.clinic?.practiceHubSettings?.isActive){
          showGlobalSnackbar(i18n.t("practiceHubActivated"));
        }else{
          showGlobalSnackbar(i18n.t("practiceHubDisabled"));
        }
      }
      setIsUpdatingActiveStatus(false);
    }
  }

  function handleSetAppointmentTypeTriggers(option) {
    setSendingInfoFormData((prevState) => {
      const currentTriggers = prevState.appointmentTypeTriggers || []; // Ensure array exists
      const isOptionAlreadySet = currentTriggers.includes(option);

      // Toggle the option: add if not present, remove if already present
      const updatedTriggers = isOptionAlreadySet
          ? currentTriggers.filter((trigger) => trigger?.id !== option?.id) // Remove the option
          : [...currentTriggers, option]; // Add the option

      return {
        ...prevState,
        appointmentTypeTriggers: updatedTriggers,
      };
    });
  }

  function handleSetNextAppointmentTypeTriggers(option) {
    setSendingInfoFormData((prevState) => {
      const currentTriggers = prevState.nextAppointmentTypeTriggers || []; // Ensure array exists
      const isOptionAlreadySet = currentTriggers.includes(option);

      // Toggle the option: add if not present, remove if already present
      const updatedTriggers = isOptionAlreadySet
          ? currentTriggers.filter((trigger) => trigger?.id !== option?.id) // Remove the option
          : [...currentTriggers, option]; // Add the option

      return {
        ...prevState,
        nextAppointmentTypeTriggers: updatedTriggers,
      };
    });
  }

  const mergeOptions = (selectedOptions = [], options = []) => {
    // Convert options to a map for easy lookup
    const optionsMap = new Map(options.map((option) => [option.id, option]));

    // Add selected options that are not in options
    selectedOptions.forEach((selected) => {
      if (!optionsMap.has(selected.id)) {
        optionsMap.set(selected.id, selected);
      }
    });

    // Return the merged list
    return Array.from(optionsMap.values());
  };


  return (
    <div className="practiceHubIncomingIntegration">
      <Box className={"sectionChange"} style={{ marginTop: 0 }}>
          <Box className={"textInputContainerIntegrations"}>
            <TextInput
              type={"password"}
              setValue={(value) =>
                setApiKeyFormData({ ...apiKeyFormData, apiKey: value })
              }
              label={i18n.t("APIKey")}
              value={apiKeyFormData?.apiKey}
              mode={"white"}
              explanation={i18n.t("keyDesc")}
              errorMessage={apiKeyErrorData?.apiKey}
            />
            <TextInput
              type={"text"}
              setValue={(value) =>
                setApiKeyFormData({ ...apiKeyFormData, accountDomain: value })
              }
              label={i18n.t("accountDomain")}
              value={apiKeyFormData?.accountDomain}
              mode={"white"}
              explanation={i18n.t("accDesc")}
              errorMessage={apiKeyErrorData?.accountDomain}
            />
            <TextInput
              type={"text"}
              setValue={(value) =>
                setApiKeyFormData({ ...apiKeyFormData, accountRegion: value })
              }
              label={i18n.t("acccountRegion")}
              value={apiKeyFormData?.accountRegion}
              mode={"white"}
              explanation={i18n.t("accRegionDesc")}
              errorMessage={apiKeyErrorData?.accountRegion}
            />

            <div className={"integrationDropdown"} style={{marginBottom:'30px'}}>
                <span className="dropdownLable">
                  {i18n.t("Timezone")}
                </span>
              <Dropdown
                  type={"timezone"}
                  setSelectedOption={(option) =>
                      setApiKeyFormData({
                        ...apiKeyFormData,
                        timezone: option,
                      })
                  }
                  shortenSelectedLabel={false}
                  selectedOption={apiKeyFormData?.timezone}
                  options={app.app_data?.timezones}
                  app={app}
                  placeholder="Select"
              />
              {sendingInfoErrorData?.["timezone.id"] &&
                  sendingInfoErrorData?.["timezone.id"]?.map(
                      (item, index) => {
                        return (
                            <div key={index} className={"errorMessage"}>
                              {item}
                            </div>
                        );
                      }
                  )}
            </div>


            <Box
              style={{ marginTop: "0px" }}
              className={"buttonContainer"}
              onClick={() => handleSetApiKey()}
            >
              <Button
                text={
                  apiKeyStatus ? (
                    <Oval
                      height={20}
                      width={20}
                      color="#fff"
                      wrapperStyle={{}}
                      wrapperClass=""
                      visible={true}
                      ariaLabel="oval-loading"
                      secondaryColor="#fff"
                      strokeWidth={2}
                      strokeWidthSecondary={2}
                    />
                  ) : (
                    i18n.t("confirmSurveyNotes")
                  )
                }
                mode={"small"}
              />
            </Box>
          </Box>
      </Box>

      {user?.user?.clinic?.hasPracticeHubIntegrated && (
        <>
          <Box className={"practiceHubIncomingSection"}>
            <div style={{ marginBottom: "30px" }}>
              <Headline
                text={i18n.t("automateProcess")}
                type={"Headline-medium"}
              />
            </div>

            <Box
              style={{ marginBottom: "30px" }}
              className={"integrationDropdownWrapper"}
            >
              <div className={"integrationDropdown"}>
                <span className="dropdownLable">
                  {i18n.t("defaultSurveyType")}
                </span>
                <Dropdown
                  type={"statistics"}
                  setSelectedOption={(option) =>
                    setSendingInfoFormData({
                      ...sendingInfoFormData,
                      defaultSurveyType: option,
                    })
                  }
                  selectedOption={sendingInfoFormData?.defaultSurveyType}
                  options={[
                    { id: 1, name: "ChiroForm" },
                    { id: 2, name: "ChiroForm +" },
                    { id: 3, name: "ChiroForm (CP)" },
                    { id: 4, name: "Wellness" },
                  ]}
                  app={app}
                  placeholder="Select"
                />
                {sendingInfoErrorData?.["defaultSurveyType.id"] &&
                  sendingInfoErrorData?.["defaultSurveyType.id"]?.map(
                    (item, index) => {
                      return (
                        <div key={index} className={"errorMessage"}>
                          {item}
                        </div>
                      );
                    }
                  )}
              </div>
              <div className={"integrationDropdown"}>
                <span className="dropdownLable">
                  {i18n.t("defaultSurveyLanguage")}
                </span>
                <Dropdown
                  type={"statistics"}
                  setSelectedOption={(option) =>
                    setSendingInfoFormData({
                      ...sendingInfoFormData,
                      defaultSurveyLanguage: option,
                    })
                  }
                  selectedOption={sendingInfoFormData?.defaultSurveyLanguage}
                  options={user?.user?.clinic?.languages}
                  app={app}
                  placeholder="Select"
                />
                {sendingInfoErrorData?.["defaultSurveyLanguage.id"] &&
                  sendingInfoErrorData?.["defaultSurveyLanguage.id"]?.map(
                    (item, index) => {
                      return (
                        <div key={index} className={"errorMessage"}>
                          {item}
                        </div>
                      );
                    }
                  )}
              </div>
            </Box>

            <Accordion
              title={"Survey 1"}
              showErrorUnderline={surveyHasErrors()}
            >
              <Box className={"integrationDropdownWrapper"}>
                <div className={"integrationDropdown"}>
                  <span className="dropdownLable">
                    {i18n.t("appointmentTypeTrigger")}
                  </span>
                  <MultiDropdown
                    setSelectedOptions={(option) =>
                      handleSetAppointmentTypeTriggers(option)
                    }
                    selectedOptions={
                      sendingInfoFormData?.appointmentTypeTriggers
                    }
                    options={mergeOptions(
                      sendingInfoFormData?.appointmentTypeTriggers ?? [],
                      user?.user?.clinic?.practiceHubSettings
                        ?.appointmentTypes ?? []
                    )}
                    placeholder="Select triggers"
                  />
                  {sendingInfoErrorData?.["appointmentTypeTriggers.id"] &&
                    sendingInfoErrorData?.["appointmentTypeTriggers.id"]?.map(
                      (item, index) => {
                        return (
                          <div key={index} className={"errorMessage"}>
                            {item}
                          </div>
                        );
                      }
                    )}
                </div>
                <div className={"integrationDropdown"}>
                  <span className="dropdownLable">
                    {i18n.t("sendSurveyAppointment")}
                  </span>
                  <div className="dropdownGridWrap">
                    <div>
                      <Dropdown
                        type={"statistics"}
                        setSelectedOption={(option) =>
                          setSendingInfoFormData({
                            ...sendingInfoFormData,
                            sendingOption: option,
                          })
                        }
                        selectedOption={sendingInfoFormData?.sendingOption}
                        options={sendingOptions}
                        app={app}
                        placeholder="Select"
                      />
                      {sendingInfoErrorData?.["sendingOption"] &&
                        sendingInfoErrorData?.["sendingOption"]?.map(
                          (item, index) => {
                            return (
                              <div key={index} className={"errorMessage"}>
                                {item}
                              </div>
                            );
                          }
                        )}
                    </div>

                    <div>
                      <Dropdown
                        type={"statistics"}
                        setSelectedOption={(option) =>
                          setSendingInfoFormData({
                            ...sendingInfoFormData,
                            numOfDaysSending: option,
                          })
                        }
                        selectedOption={sendingInfoFormData?.numOfDaysSending}
                        options={numOfDaysOptions}
                        app={app}
                        placeholder="Select"
                      />
                      {sendingInfoErrorData?.["numOfDaysSending"] &&
                        sendingInfoErrorData?.["numOfDaysSending"]?.map(
                          (item, index) => {
                            return (
                              <div key={index} className={"errorMessage"}>
                                {item}
                              </div>
                            );
                          }
                        )}
                    </div>
                  </div>
                </div>

                <div className={"integrationDropdown"}>
                  <TextInput
                    maxlength={500}
                    type={"text"}
                    setValue={(value) =>
                      setSendingInfoFormData({
                        ...sendingInfoFormData,
                        emailSubject: value,
                      })
                    }
                    label={i18n.t("emailSubject")}
                    value={sendingInfoFormData?.emailSubject}
                    mode={"white"}
                    errorMessage={sendingInfoErrorData?.emailSubject}
                  />
                </div>

                <div className={"integrationDropdown"}>
                  <TextInput
                    maxlength={500}
                    type={"textarea"}
                    setValue={(value) =>
                      setSendingInfoFormData({
                        ...sendingInfoFormData,
                        emailBody: value,
                      })
                    }
                    label={i18n.t("emailBody")}
                    value={sendingInfoFormData?.emailBody}
                    mode={"white"}
                    errorMessage={sendingInfoErrorData?.emailBody}
                  />
                </div>

                <div className="autoClinicEmail" style={{ marginTop: "0" }}>
                  <label>
                    <input
                      type="checkbox"
                      checked={sendingInfoFormData?.sendEmailToPatient}
                      onChange={() =>
                        setSendingInfoFormData({
                          ...sendingInfoFormData,
                          sendEmailToPatient:
                            !sendingInfoFormData?.sendEmailToPatient,
                        })
                      }
                    />{" "}
                    Send emails to patients
                  </label>
                </div>

                <div
                  className="autoClinicEmail"
                  style={{ marginTop: "0", marginBottom: "30px" }}
                >
                  <label>
                    <input
                      type="checkbox"
                      checked={sendingInfoFormData?.sendEmailToClinic}
                      onChange={() =>
                        setSendingInfoFormData({
                          ...sendingInfoFormData,
                          sendEmailToClinic:
                            !sendingInfoFormData?.sendEmailToClinic,
                        })
                      }
                    />{" "}
                    Send emails to clinic
                  </label>
                  {!!sendingInfoFormData?.sendEmailToClinic && (
                      <div
                          style={{
                              display: "flex",
                              alignItems: "stretch",
                          }}
                      >
                          <TextInput
                              type={"email"}
                              label={i18n.t("Clinic email")}
                              setValue={(value) =>
                                  setSendingInfoFormData({
                                      ...sendingInfoFormData,
                                      sendEmailToClinicAddress: value,
                                  })
                              }
                              value={sendingInfoFormData?.sendEmailToClinicAddress}
                              errorMessage={
                                  sendingInfoErrorData?.sendEmailToClinicAddress
                              }
                              mode={"white"}
                          />
                      </div>
                  )}
                </div>
              </Box>
            </Accordion>

            <Accordion
              title={"Survey 2-6"}
              showErrorUnderline={surveyNextHasErrors()}
            >
              <Box className={"integrationDropdownWrapper"}>
                <div className={"integrationDropdown"}>
                  <span className="dropdownLable">
                    {i18n.t("appointmentTypeTrigger")}
                  </span>
                  <MultiDropdown
                    setSelectedOptions={(option) =>
                      handleSetNextAppointmentTypeTriggers(option)
                    }
                    selectedOptions={
                      sendingInfoFormData?.nextAppointmentTypeTriggers
                    }
                    options={mergeOptions(
                      sendingInfoFormData?.nextAppointmentTypeTriggers ?? [],
                      user?.user?.clinic?.practiceHubSettings
                        ?.appointmentTypes ?? []
                    )}
                    placeholder="Select triggers"
                  />
                  {sendingInfoErrorData?.["nextAppointmentTypeTriggers.id"] &&
                    sendingInfoErrorData?.[
                      "nextAppointmentTypeTriggers.id"
                    ]?.map((item, index) => {
                      return (
                        <div key={index} className={"errorMessage"}>
                          {item}
                        </div>
                      );
                    })}
                </div>
                <div className={"integrationDropdown"}>
                  <span className="dropdownLable">
                    {i18n.t("sendSurveyAppointment")}
                  </span>
                  <div className="dropdownGridWrap">
                    <div>
                      <Dropdown
                        type={"statistics"}
                        setSelectedOption={(option) =>
                          setSendingInfoFormData({
                            ...sendingInfoFormData,
                            nextSendingOption: option,
                          })
                        }
                        selectedOption={sendingInfoFormData?.nextSendingOption}
                        options={sendingOptions}
                        app={app}
                        placeholder="Select"
                      />
                      {sendingInfoErrorData?.["nextSendingOption"] &&
                        sendingInfoErrorData?.["nextSendingOption"]?.map(
                          (item, index) => {
                            return (
                              <div key={index} className={"errorMessage"}>
                                {item}
                              </div>
                            );
                          }
                        )}
                    </div>

                    <div>
                      <Dropdown
                        type={"statistics"}
                        setSelectedOption={(option) =>
                          setSendingInfoFormData({
                            ...sendingInfoFormData,
                            nextNumOfDaysSending: option,
                          })
                        }
                        selectedOption={
                          sendingInfoFormData?.nextNumOfDaysSending
                        }
                        options={numOfDaysOptions}
                        app={app}
                        placeholder="Select"
                      />
                      {sendingInfoErrorData?.["nextNumOfDaysSending"] &&
                        sendingInfoErrorData?.["nextNumOfDaysSending"]?.map(
                          (item, index) => {
                            return (
                              <div key={index} className={"errorMessage"}>
                                {item}
                              </div>
                            );
                          }
                        )}
                    </div>
                  </div>
                </div>

                <div className={"integrationDropdown"}>
                  <TextInput
                    maxlength={500}
                    type={"text"}
                    setValue={(value) =>
                      setSendingInfoFormData({
                        ...sendingInfoFormData,
                        emailSubjectNext: value,
                      })
                    }
                    label={i18n.t("emailSubject")}
                    value={sendingInfoFormData?.emailSubjectNext}
                    mode={"white"}
                    errorMessage={sendingInfoErrorData?.emailSubjectNext}
                  />
                </div>

                <div className={"integrationDropdown"}>
                  <TextInput
                    maxlength={500}
                    type={"textarea"}
                    setValue={(value) =>
                      setSendingInfoFormData({
                        ...sendingInfoFormData,
                        emailBodyNext: value,
                      })
                    }
                    label={i18n.t("emailBody")}
                    value={sendingInfoFormData?.emailBodyNext}
                    mode={"white"}
                    errorMessage={sendingInfoErrorData?.emailBodyNext}
                  />
                </div>

                <div className="autoClinicEmail" style={{ marginTop: "0" }}>
                  <label>
                    <input
                      type="checkbox"
                      checked={sendingInfoFormData?.nextSendEmailToPatient}
                      onChange={() =>
                        setSendingInfoFormData({
                          ...sendingInfoFormData,
                          nextSendEmailToPatient:
                            !sendingInfoFormData?.nextSendEmailToPatient,
                        })
                      }
                    />{" "}
                    Send emails to patients
                  </label>
                </div>

                <div
                  className="autoClinicEmail"
                  style={{ marginTop: "0", marginBottom: "30px" }}
                >
                  <label>
                    <input
                      type="checkbox"
                      checked={sendingInfoFormData?.nextSendEmailToClinic}
                      onChange={() =>
                        setSendingInfoFormData({
                          ...sendingInfoFormData,
                          nextSendEmailToClinic:
                            !sendingInfoFormData?.nextSendEmailToClinic,
                        })
                      }
                    />{" "}
                    Send emails to clinic
                  </label>
                  {!!sendingInfoFormData?.nextSendEmailToClinic && (
                      <div
                          style={{
                              display: "flex",
                              alignItems: "stretch",
                          }}
                      >
                            <TextInput
                              type={"email"}
                              label={i18n.t("Clinic email")}
                              setValue={(value) =>
                                setSendingInfoFormData({
                                  ...sendingInfoFormData,
                                  nextSendEmailToClinicAddress: value,
                                })
                              }
                              value={sendingInfoFormData?.nextSendEmailToClinicAddress}
                              mode={"white"}
                              errorMessage={
                                sendingInfoErrorData?.nextSendEmailToClinicAddress
                              }
                            />
                      </div>
                  )}
                </div>
              </Box>
            </Accordion>

            <Box
              style={{ marginTop: "24px" }}
              className={"buttonContainer"}
              onClick={() => handleSendingInfo()}
            >
              <Button
                text={
                  sendingInfoStatus ? (
                    <Oval
                      height={20}
                      width={20}
                      color="#fff"
                      wrapperStyle={{}}
                      wrapperClass=""
                      visible={true}
                      ariaLabel="oval-loading"
                      secondaryColor="#fff"
                      strokeWidth={2}
                      strokeWidthSecondary={2}
                    />
                  ) : (
                    i18n.t("saveSync")
                  )
                }
                mode={"small"}
              />
            </Box>
          </Box>

          {/* MANUAL SYNC */}
          {user?.user?.clinic?.practiceHubSettings?.canFetchUsers && (
            <Box className={"practiceHubIncomingSection"}>
              <Headline
                text={i18n.t("manualSyncOptions")}
                type={"Headline-medium"}
              />
              <p style={{ marginTop: "42px", maxWidth: "580px" }}>
                {i18n.t("manualDesc")}
              </p>
              <Box
                style={{ marginTop: "10px", marginBottom: "40px" }}
                className={"buttonContainer"}
                onClick={() => handleSyncUsers()}
              >
                <Button
                  text={
                    syncUsersStatus ? (
                      <Oval
                        height={20}
                        width={20}
                        color="#fff"
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                        ariaLabel="oval-loading"
                        secondaryColor="#fff"
                        strokeWidth={2}
                        strokeWidthSecondary={2}
                      />
                    ) : (
                      i18n.t("syncNow")
                    )
                  }
                  mode={"small"}
                />
              </Box>
            </Box>
          )}
          {/* END MANUAL SYNC */}

          {/*ACTIVE/DISABLE SYNCING*/}
          {user?.user?.clinic?.hasPracticeHubIntegrated && (
            <Box style={{ marginTop: "30px" }}>
              <p>
                To{" "}
                {user?.user?.clinic?.practiceHubSettings?.isActive
                  ? "disable"
                  : "activate"}{" "}
                the PracticeHub integration, and{" "}
                {user?.user?.clinic?.practiceHubSettings?.isActive == false
                  ? "start"
                  : "end"}{" "}
                syncing, click here
              </p>

              {user?.user?.clinic?.practiceHubSettings?.isActive ? (
                <Box
                  style={{ marginTop: "10px", marginBottom: "40px" }}
                  className={"buttonContainer"}
                  onClick={() => handleToggleActive()}
                >
                  <Button
                    text={
                      isUpdatingActiveStatus ? (
                        <Oval
                          height={20}
                          width={20}
                          color="#fff"
                          wrapperStyle={{}}
                          wrapperClass=""
                          visible={true}
                          ariaLabel="oval-loading"
                          secondaryColor="#fff"
                          strokeWidth={2}
                          strokeWidthSecondary={2}
                        />
                      ) : (
                        "Stop Sync"
                      )
                    }
                    mode={"small"}
                    color={"red"}
                  />
                </Box>
              ) : (
                <Box
                  style={{ marginTop: "10px", marginBottom: "40px" }}
                  className={"buttonContainer"}
                  onClick={() => handleToggleActive()}
                >
                  <Button
                    text={
                      isUpdatingActiveStatus ? (
                        <Oval
                          height={20}
                          width={20}
                          color="#fff"
                          wrapperStyle={{}}
                          wrapperClass=""
                          visible={true}
                          ariaLabel="oval-loading"
                          secondaryColor="#fff"
                          strokeWidth={2}
                          strokeWidthSecondary={2}
                        />
                      ) : (
                        "Activate Syncing"
                      )
                    }
                    mode={"small"}
                  />
                </Box>
              )}
            </Box>
          )}
          {/* END ACTIVE/DISABLE SYNCING*/}

          {/* FAILED TO SYNC USERS */}
          {user?.user?.clinic?.practiceHubSettings?.failedToSyncUsersData
            ?.length !== 0 && (
            <>
              <Box className={"practiceHubIncomingSection"}>
                <Headline
                  text={i18n.t("failedToSyncTitle")}
                  type={"Headline-medium"}
                />
                <p style={{ marginTop: "42px", maxWidth: "580px" }}>
                  {i18n.t("failedToSyncDesc")}
                </p>

                <Box
                  style={{ marginTop: "10px", marginBottom: "40px" }}
                  className={"buttonContainer"}
                  onClick={() => setShowFailedSyncUsers(true)}
                >
                  <Button text={i18n.t("failedToSyncButton")} mode={"small"} />
                </Box>
              </Box>

              {showFailedSyncUsers && (
                <div className="ScreenOverlay">
                  <div className="ScreenContent">
                    <h2>Patients Not Fully Synced</h2>

                    <div
                      style={{
                        padding: "10px",
                        textAlign: "center",
                        maxHeight: "50vh",
                        overflow: "hidden",
                        overflowY: "auto",
                      }}
                    >
                      {user?.user?.clinic?.practiceHubSettings?.failedToSyncUsersData?.map(
                        (item, index) => {
                          return (
                            <div
                              key={index}
                              style={{
                                marginBottom: "10px",
                              }}
                            >
                              <div
                                id={`tooltip_${item.id}`}
                                style={{ cursor: "pointer" }}
                              >
                                <strong>
                                  {item?.firstName} {item?.lastName}:
                                </strong>{" "}
                                <span style={{ color: "red" }}>
                                  {item?.reason}
                                </span>
                                <ReactTooltip
                                  anchorId={`tooltip_${item.id}`}
                                  place="right"
                                  content={`PracticeHub ID: ${item?.id}`}
                                />
                              </div>
                            </div>
                          );
                        }
                      )}
                    </div>

                    <Box
                      style={{ marginTop: "10px", marginBottom: "40px" }}
                      className={"buttonContainer"}
                      onClick={() => setShowFailedSyncUsers(false)}
                    >
                      <Button text={i18n.t("Close")} mode={"small"} />
                    </Box>
                  </div>
                </div>
              )}
            </>
          )}
          {/* END FAILED TO SYNC USERS */}
        </>
      )}
    </div>
  );
};

export default PracticeHubIncomingIntegration;
